<script setup lang="ts">
    import { onMounted, ref, watch } from 'vue';
    import ConfirmationModal from './ConfirmationModal.vue';
    import { useConfirmationStore } from '@/stores/confirmation.store';

    const confirmationStore = useConfirmationStore();
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);

    onMounted(() => {
        confirmationStore.init(confirmationModalRef);
    })
</script>
<template>
    <confirmation-modal ref="confirmationModalRef"></confirmation-modal>
</template>